import { Trans } from 'react-i18next';

interface IProps {
  fileName: string;
  minImageWidth: number;
  allowTranslation: boolean;
}

const ErrorImageSize = ({ fileName, minImageWidth, allowTranslation = false }: IProps) =>
  allowTranslation ? (
    <span>
      <Trans ns="ui" i18nKey="photoUploadImageSize.validation">
        {{ fileName }}
        <div>wasn't uploaded.</div>
        <div>
          <span>Photo needs to be at least </span>
          <strong>{{ minImageWidth }}px </strong>
          <span>wide</span>
        </div>
      </Trans>
    </span>
  ) : (
    <span>
      {fileName}
      <div>wasn't uploaded.</div>
      <div>
        <span>Photo needs to be at least </span>
        <strong>{minImageWidth}px </strong>
        <span>wide</span>
      </div>
    </span>
  );

export default ErrorImageSize;
